import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faObjectsColumn, faHouse, faUsersGear, faMessagePen, faBook, faCirclePlay, faClipboardUser } from '@fortawesome/free-regular-svg-icons';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from "react-bootstrap";
import Apiservice from '../Apiservice';

const Sidemenubar = ({ onClick }) => {
    const navigate = useNavigate();
    const userType = localStorage.getItem('userType') || '';
    const [cpdDropdown, setCpdDropdown] = useState(false);
    const [reportDropDown, setReportDropDown] = useState(false);
    const [role, setRole] = useState("");
    const [loggedRoleId, setLoggedRoleId] = useState(0);
    const [loggedSiteId, setLoggedSiteId] = useState(() => {
        const siteId = localStorage.getItem("siteId");
        return siteId ? Number(siteId) : null;
    });

    const [activeItem, setActiveItem] = useState(""); // To track active item
    const [subActiveItem, setSubActiveItem] = useState("");

    const [showLogOutModal, setShowLogOutModal] = useState(false);

    const [noOfIncidentReport, setNoOfIncidentReport] = useState(0);
    const [refresh, setRefresh] = useState(false);   // <--- important

    const [acadamics, setAcadamics] = useState([]);

    console.log("side body")
    // Fetch role data from API
    useEffect(() => {
        if (userType !== 'normal') return; // ❗ important
        const fetchData = async () => {
            let data = { role_id: localStorage.getItem('role_id'), userType: "normal", status: 0 };
            setLoggedRoleId(localStorage.getItem('role_id'));
            const token = localStorage.getItem("access_token");
            const headers = { access_token: token };
            // let result = await Apiservice.GetRoleById(data, headers);
            let result = await Apiservice.SideMenubarPage(data, headers);
            console.log("roleresult", result)
            if (result.success) {

                let retrievedRoleDetails = result.data.roleDetails || [];

                let retrievedAcademics = result.data.acadamics || [];

                setRole(retrievedRoleDetails[0]?.name || "");

                console.log("retriveA", retrievedAcademics);

                setAcadamics(retrievedAcademics);

            } else {
                alert('Internal server error, side menu bar');
            }
        };
        fetchData();
    }, [userType]);

    useEffect(() => {
        if (loggedRoleId == 1) {
            const fetchData = async () => {
                let data = {
                    isView: 0,
                    status: 0,
                };

                let result = await Apiservice.IncidentReportGet(data);

                if (result.success === true) {
                    let retrievedData = result.data;
                    setNoOfIncidentReport(retrievedData.length);
                } else {
                    setNoOfIncidentReport(0);
                }
            };

            // ✅ Initial call
            fetchData();

            // 👇 Listen for updates
            const handleIncidentViewed = () => {
                fetchData();
            };

            window.addEventListener("incidentViewed", handleIncidentViewed);

            return () => {
                window.removeEventListener("incidentViewed", handleIncidentViewed);
            };
        }
    }, [loggedRoleId, refresh]); // <--- key fix



    const updateStatus = async (id) => {
        let res = await Apiservice.ChangeIncidentStatus({ id, status: 1 });

        if (res.success) {
            setRefresh(prev => !prev);  // <--- refresh badge
        }
    };


    // useEffect(() => {
    //     const handleStorageChange = () => {
    //         setLoggedSiteId(Number(localStorage.getItem("siteId")) || 0);
    //     };

    //     window.addEventListener("storage", handleStorageChange);
    //     return () => window.removeEventListener("storage", handleStorageChange);
    // }, []);
    useEffect(() => {
        const handleSiteIdChange = () => {
            setLoggedSiteId(Number(localStorage.getItem("siteId")) || 0);
        };

        // listen for custom event
        window.addEventListener("siteIdChanged", handleSiteIdChange);

        return () => {
            window.removeEventListener("siteIdChanged", handleSiteIdChange);
        };
    }, []);


    // const handleLogout = () => setShowLogOutModal(true);
    const handleLogoutConfirm = () => {
        localStorage.clear();
        navigate('/login');
    };

    const handleNavigation = (sectionId) => {
        setActiveItem(sectionId);  // Mark the item as active
        navigate('/overviewofcourse', { state: { sectionId } });
    };

    const handleAcadamic = (academicId) => {
        // setActiveItem(ac);  // Mark the item as active
        navigate('/overviewofcourse', { state: { academicId } });
    };

    const handleProfileClick = () => {
        setActiveItem('profile');
        navigate(`/staffprofile/${localStorage.getItem("user_id")}`);
    };
    const handleAttendanceClick = () => {
        setActiveItem('attendance');
        //navigate(`/staffprofile/${localStorage.getItem("user_id")}`);
        if (userType === 'normal') {
            navigate('/attendance');
        }
        else {
            navigate('/floaterattendance')
        }

    };

    return (
        <>
            <div className="container-fluid shadow" style={{ position: 'relative', overflow: 'hidden', userSelect: 'none' }}>

                <div className="row p-2 mb-2" style={{ position: 'sticky', top: '60px', zIndex: 10, background: '#fff', cursor: 'pointer' }}>
                    <div className="col p-2">
                        <ul className="list-group">
                            {(role === "Super Admin" || role === "Admin") ? (
                                <>
                                    {/* Home*/}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'home' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('home'); setSubActiveItem(''); navigate('/home'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faHouse} /></div> */}
                                            <div className="col">Home</div>
                                        </div>
                                    </li>

                                    {/* Dashboard */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'dashboard' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('dashboard'); setSubActiveItem(''); navigate('/dashboard'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faObjectsColumn} /></div> */}
                                            <div className="col">Dashboard</div>
                                        </div>
                                    </li>

                                    {/* Site Management */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'site' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('site'); setSubActiveItem(''); navigate('/sites'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faUsersGear} /></div> */}
                                            <div className="col">Site Management</div>
                                        </div>
                                    </li>

                                    {/* Staffs */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'staff' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('staff'); setSubActiveItem(''); navigate('/allstaff'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faUsersGear} /></div> */}
                                            <div className="col">Staff Management</div>
                                        </div>
                                    </li>
                                    {/* Payslip Management */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'payslip' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('payslip'); setSubActiveItem(''); navigate('/salariedstaff'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">Payslip</div>
                                        </div>
                                    </li>
                                    {/* occurrence */}

                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'occurrence' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('occurrence'); setSubActiveItem(''); navigate('/eoccurrence'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">E-Occurrence</div>
                                        </div>
                                    </li>

                                    {/* SOP */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'sop' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('sop'); setSubActiveItem(''); navigate('/sop'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">SOP</div>
                                        </div>
                                    </li>

                                    <li
                                        className={`list-group-item list-group-item-action px-3 d-flex justify-content-between align-items-center sidebar-item ${activeItem === 'incident' ? 'active' : ''}`}
                                        onClick={() => {
                                            setActiveItem("incident");
                                            setSubActiveItem("");
                                            navigate("/incidentreport");
                                            window.innerWidth < 768 && onClick();
                                        }}
                                    >
                                        <span>Incident Report</span>

                                        {/* BADGE */}
                                        {Number(noOfIncidentReport) > 0 && (
                                            <span className="badge rounded-pill bg-danger">
                                                {noOfIncidentReport}
                                            </span>
                                        )}
                                    </li>

                                    {/* Quiz Management */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'quizManagement' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('quizManagement'); setSubActiveItem(''); navigate('/quizlist'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">Quiz Management</div>
                                        </div>
                                    </li>


                                    {/* Profile */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'profile' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('profile'); setSubActiveItem(''); handleProfileClick(); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faUsersGear} /></div> */}
                                            <div className="col">My Profile</div>
                                        </div>
                                    </li>
                                    {/* Attendance */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'attendance' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('attendance'); setSubActiveItem(''); handleAttendanceClick(); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faUsersGear} /></div> */}
                                            <div className="col">Attendance</div>
                                        </div>
                                    </li>

                                    {/* CPD Security Training */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'cpd' ? 'rgb(131, 79, 194)' : ''}`}
                                        onClick={() => { setCpdDropdown(!cpdDropdown); setSubActiveItem(''); setActiveItem('cpd'); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">CPD Security Training</div>
                                        </div>
                                    </li>
                                    {cpdDropdown && (
                                        <>
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === 'overview' ? 'subactive' : ''}`}
                                                onClick={() => { setSubActiveItem('overview'); handleNavigation(4); window.innerWidth < 768 && onClick(); setActiveItem(''); }}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    {/* <div className="col-2"><FontAwesomeIcon icon={faBook} /></div> */}
                                                    <div className="col">Overview of Course</div>
                                                </div>
                                            </li>
                                            {
                                                acadamics.length > 0 &&
                                                acadamics.map((acadamic) => (
                                                    <li
                                                        key={acadamic.id}
                                                        className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === acadamic.id ? 'subactive' : ''}`}
                                                        onClick={() => {
                                                            setSubActiveItem(acadamic.id);
                                                            handleAcadamic(acadamic.id);
                                                            setActiveItem('');
                                                            if (window.innerWidth < 768) {
                                                                onClick();
                                                            }
                                                        }}
                                                    >
                                                        <div className="row">
                                                            <div className="col-1"></div>

                                                            <div className="col">
                                                                {acadamic.acadamic}
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))
                                            }


                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === 'overall' ? 'rgb(182, 160, 208)' : ''}`}
                                                onClick={() => { setSubActiveItem('overall'); navigate('/quiz/0'); window.innerWidth < 768 && onClick(); setActiveItem(''); }}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    {/* <div className="col-2"><FontAwesomeIcon icon={faClipboardUser} /></div> */}
                                                    <div className="col">Overall Quiz</div>
                                                </div>
                                            </li>
                                        </>
                                    )}

                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'report' ? 'active' : ''}`}
                                        onClick={() => { setReportDropDown(!reportDropDown); setActiveItem('report'); setSubActiveItem(''); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">Report</div>
                                        </div>
                                    </li>
                                    {reportDropDown && (
                                        <>
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === 'attendancereport' ? 'subactive' : ''}`}
                                                onClick={() => { setSubActiveItem('attendancereport'); navigate('/attendancereport'); window.innerWidth < 768 && onClick(); setActiveItem(''); }}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    {/* <div className="col-2"><FontAwesomeIcon icon={faBook} /></div> */}
                                                    <div className="col">Attendance Report</div>
                                                </div>
                                            </li>
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === 'timesheet' ? 'subactive' : ''}`}
                                                onClick={() => { setSubActiveItem('timesheet'); navigate('/timesheet'); window.innerWidth < 768 && onClick(); setActiveItem(''); }}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    {/* <div className="col-2"><FontAwesomeIcon icon={faBook} /></div> */}
                                                    <div className="col">Time Sheet</div>
                                                </div>
                                            </li>
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'eoccurrencereport' ? 'subactive' : ''}`}
                                                onClick={() => { setSubActiveItem('eoccurrencereport'); navigate('/eoccurrencereport'); window.innerWidth < 768 && onClick(); setActiveItem(''); }}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    {/* <div className="col-2"><FontAwesomeIcon icon={faBook} /></div> */}
                                                    <div className="col">E-Occurrence Report</div>
                                                </div>
                                            </li>
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === 'LMSReport' ? 'subactive' : ''}`}
                                                onClick={() => { setSubActiveItem('LMSReport'); navigate('/lmsreport'); window.innerWidth < 768 && onClick(); setActiveItem(''); }}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-2"><FontAwesomeIcon icon={faCirclePlay} /></div>
                                                    <div className="col">LMS Report</div>
                                                </div>
                                            </li>
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === 'consolidate' ? 'subactive' : ''}`}
                                                onClick={() => { setSubActiveItem('consolidate'); navigate('/consolidate'); window.innerWidth < 768 && onClick(); setActiveItem(''); }}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-2"><FontAwesomeIcon icon={faCirclePlay} /></div>
                                                    <div className="col">Consolidate Report</div>
                                                </div>
                                            </li>
                                        </>
                                    )}

                                </>
                            ) : userType === "normal" ? (
                                <>
                                    {/* Home*/}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'home' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('home'); setSubActiveItem(''); navigate('/home'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faHouse} /></div> */}
                                            <div className="col">Home</div>
                                        </div>
                                    </li>
                                    {/* Profile */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'profile' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('profile'); setSubActiveItem(''); handleProfileClick(); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faUsersGear} /></div> */}
                                            <div className="col">My Profile</div>
                                        </div>
                                    </li>
                                    {/* Attendance */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'attendance' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('attendance'); setSubActiveItem(''); handleAttendanceClick(); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faUsersGear} /></div> */}
                                            <div className="col">Attendance</div>
                                        </div>
                                    </li>
                                    {/* Payslip Management */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'payslip' ? 'active' : ''}`}
                                        onClick={() => {
                                            setActiveItem('payslip'); setSubActiveItem('');
                                            navigate('/paysliplist', {
                                                state: { staffId: localStorage.getItem("user_id") }
                                            });
                                            window.innerWidth < 768 && onClick();
                                        }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">Payslip</div>
                                        </div>
                                    </li>
                                    {/* occurrence */}
                                    {
                                        Boolean(loggedSiteId) && (
                                            <>
                                                <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'occurrence' ? 'active' : ''}`}
                                                    onClick={() => { setActiveItem('occurrence'); setSubActiveItem(''); loggedRoleId > 1 ? navigate('/eoccurrenceadd') : navigate('/eoccurrence'); window.innerWidth < 768 && onClick(); }}>
                                                    <div className="row">
                                                        {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                                        <div className="col">E-Occurrence</div>
                                                    </div>
                                                </li>
                                            </>
                                        )

                                    }
                                    {/* SOP */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'sop' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('sop'); setSubActiveItem(''); navigate('/sop'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">SOP</div>
                                        </div>
                                    </li>


                                    {/* incident report*/}
                                    {
                                        Boolean(loggedSiteId) && (
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'incident' ? 'active' : ''}`}
                                                onClick={() => { setActiveItem('incident'); setSubActiveItem(''); navigate('/incidentreport'); window.innerWidth < 768 && onClick(); }}>
                                                <div className="row">
                                                    {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                                    <div className="col">Incident Report</div>
                                                </div>
                                            </li>
                                        )
                                    }

                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'leave' ? 'active' : ''}`}
                                        onClick={() => { setActiveItem('leave'); setSubActiveItem(''); navigate('/leaveapplicationlist'); window.innerWidth < 768 && onClick(); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">Leave Entitlement</div>
                                        </div>
                                    </li>


                                    {/* CPD Security Training */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'cpd' ? 'active' : ''}`}
                                        onClick={() => { setCpdDropdown(!cpdDropdown); setSubActiveItem(''); setActiveItem('cpd'); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">CPD Security Training</div>
                                        </div>
                                    </li>
                                    {cpdDropdown && (
                                        <>
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === 'overview' ? 'active' : ''}`}
                                                onClick={() => { setSubActiveItem('overview'); handleNavigation(4); window.innerWidth < 768 && onClick(); }}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    {/* <div className="col-2"><FontAwesomeIcon icon={faBook} /></div> */}
                                                    <div className="col">Overview of Course</div>
                                                </div>
                                            </li>

                                            {
                                                acadamics.length > 0 &&
                                                acadamics.map((acadamic) => (
                                                    <li
                                                        key={acadamic.id}
                                                        className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === acadamic.id ? 'subactive' : ''}`}
                                                        onClick={() => {
                                                            setSubActiveItem(acadamic.id);
                                                            handleAcadamic(acadamic.id);
                                                            setActiveItem('');
                                                            if (window.innerWidth < 768) {
                                                                onClick();
                                                            }
                                                        }}
                                                    >
                                                        <div className="row">
                                                            <div className="col-1"></div>

                                                            <div className="col">
                                                                {acadamic.acadamic}
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))
                                            }
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === 'overall' ? 'active' : ''}`}
                                                onClick={() => { setSubActiveItem('overall'); navigate('/quiz/0'); window.innerWidth < 768 && onClick(); setActiveItem(''); }}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    {/* <div className="col-2"><FontAwesomeIcon icon={faClipboardUser} /></div> */}
                                                    <div className="col">Overall Quiz</div>
                                                </div>
                                            </li>
                                        </>
                                    )}
                                    {/* Report */}
                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'report' ? 'report' : ''}`}
                                        onClick={() => { setReportDropDown(!reportDropDown); setActiveItem('report'); setSubActiveItem(''); }}>
                                        <div className="row">
                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                            <div className="col">Report</div>
                                        </div>
                                    </li>
                                    {reportDropDown && (
                                        <>
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === 'attendancereport' ? 'subactive' : ''}`}
                                                onClick={() => { setSubActiveItem('attendancereport'); navigate('/attendancereport'); window.innerWidth < 768 && onClick(); setActiveItem('');}}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    {/* <div className="col-2"><FontAwesomeIcon icon={faBook} /></div> */}
                                                    <div className="col">Attendance Report</div>
                                                </div>
                                            </li>
                                            <li className={`list-group-item list-group-item-action px-3 sidebar-item ${subActiveItem === 'LMSReport' ? 'subactive' : ''}`}
                                                onClick={() => { setSubActiveItem('LMSReport'); navigate('/lmsreport'); window.innerWidth < 768 && onClick(); setActiveItem('');}}>
                                                <div className="row">
                                                    <div className="col-1"></div>
                                                    <div className="col-2"><FontAwesomeIcon icon={faCirclePlay} /></div>
                                                    <div className="col">LMS Report</div>
                                                </div>
                                            </li>
                                        </>
                                    )}


                                </>
                            )
                                :
                                (
                                    <>
                                        {/* Home*/}
                                        <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'home' ? 'active' : ''}`}
                                            onClick={() => { setActiveItem('home'); setSubActiveItem(''); navigate('/home'); window.innerWidth < 768 && onClick(); }}>
                                            <div className="row">
                                                {/* <div className="col-2"><FontAwesomeIcon icon={faHouse} /></div> */}
                                                <div className="col">Home</div>
                                            </div>
                                        </li>

                                        {/* Attendance */}
                                        <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'attendance' ? 'active' : ''}`}
                                            onClick={() => { setActiveItem('attendance'); setSubActiveItem(''); handleAttendanceClick(); window.innerWidth < 768 && onClick(); }}>
                                            <div className="row">
                                                {/* <div className="col-2"><FontAwesomeIcon icon={faUsersGear} /></div> */}
                                                <div className="col">Attendance</div>
                                            </div>
                                        </li>

                                        {/* occurrence */}
                                        {
                                            Boolean(loggedSiteId) && (
                                                <>
                                                    <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'occurrence' ? 'active' : ''}`}
                                                        onClick={() => { setActiveItem('occurrence'); setSubActiveItem(''); navigate('/eoccurrenceadd'); window.innerWidth < 768 && onClick(); }}>
                                                        <div className="row">
                                                            {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                                            <div className="col">E-Occurrence</div>
                                                        </div>
                                                    </li>
                                                </>
                                            )

                                        }
                                        {/* SOP */}
                                        <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'sop' ? 'active' : ''}`}
                                            onClick={() => { setActiveItem('sop'); setSubActiveItem(''); navigate('/sop'); window.innerWidth < 768 && onClick(); }}>
                                            <div className="row">
                                                {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                                <div className="col">SOP</div>
                                            </div>
                                        </li>


                                        {/* incident report*/}
                                        {
                                            Boolean(loggedSiteId) && (
                                                <li className={`list-group-item list-group-item-action px-3 sidebar-item ${activeItem === 'incident' ? 'active' : ''}`}
                                                    onClick={() => { setActiveItem('incident'); setSubActiveItem(''); navigate('/incidentreport'); window.innerWidth < 768 && onClick(); }}>
                                                    <div className="row">
                                                        {/* <div className="col-2"><FontAwesomeIcon icon={faMessagePen} /></div> */}
                                                        <div className="col">Incident Report</div>
                                                    </div>
                                                </li>
                                            )
                                        }

                                    </>
                                )
                            }
                        </ul>
                    </div>
                </div>
            </div >
            <Modal show={showLogOutModal} onHide={() => setShowLogOutModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Log Out</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to log out?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowLogOutModal(false)}>
                        Close
                    </Button>
                    <Button variant="danger" onClick={handleLogoutConfirm} onTouchStart={handleLogoutConfirm}>
                        Log Out
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Sidemenubar;
